import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import FeedbackPage from "./pages/FeedbackPage";
import ErrorPage from "./pages/ErrorPage";

import auth from './cognito-auth/cognitoAuth';
import UserInfoStore from './cognito-auth/user-info-store';
import UserInfoApi from './cognito-auth/user-info-api';
import store from './store/index.js'; // path to your Vuex store
import jwt_decode from "jwt-decode";

Vue.use(VueRouter);

const routes = [
  {path: '/', name: "Home", component: HomePage, beforeEnter: requireAuth},
  {path: '/login', name: 'login', component: AuthPage},
  {path: '/error', name: "error", component: ErrorPage},
  {path: '/feedback', name: 'Feedback', component: FeedbackPage, beforeEnter: requireAuth},
  {
    path: '/login/oauth2/code/cognito', beforeEnter(){
      var currUrl = window.location.href;
      auth.auth.parseCognitoWebResponse(currUrl);
    }
  },
];

const router = new VueRouter({routes: routes, mode: 'history' });

function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
      UserInfoStore.setLoggedIn(false);
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
  } else {
    UserInfoApi.getUserInfo().then(response => {
      let user_id = '';
      let token = auth.auth.getSignInUserSession().getIdToken().jwtToken;
      var identities = jwt_decode(token).identities;
      if(identities) {
        let provider = "login.new-pmo-" + process.env.VUE_APP_STAGE;
        user_id =  identities.find(item => item.providerName === provider).userId;
      } 
      UserInfoStore.setLoggedIn(true);
      store.commit("setUserFirstName", response["name"]);
      store.commit("setUserLastName", response["family_name"]);
      store.commit("setUserEmail", response["email"]);
      store.commit("setUserId", user_id);
      UserInfoStore.setCognitoInfo(response);
      next();
    });
  }
}


export default router;
